<template>
	<div>
		<div class="modal-card" style="width: auto">
			<header class="modal-card-head">
				<p class="modal-card-title">Notificaciones</p>
				<button
					type="button"
					class="delete"
					@click="$emit('close')"/>
			</header>
			<section class="modal-card-body">

				<promotion v-for="(notification, index) in notifications" :key="index" 
					v-bind:title="notification.title"
					v-bind:starts_on="notification.starts_on"
					v-bind:finish_on="notification.finish_on"
					v-bind:subtitle="notification.subtitle"
					v-bind:content="notification.content">
				</promotion>

			</section>
			<!-- <footer class="modal-card-foot">
				<b-button
					label="Close"
					@click="$emit('close')" />
			</footer> -->
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import promotion from '../components/notificacion/promo.vue'

export default {
	data() {
		return {
			isActive: true,
			// notifications: null
		}
	},
	computed: {
		...mapGetters({
			notifications: 'notifications/notifications',  
		})
	},
	components:{
		promotion
	}
}
</script>

<style>
    /* .notification {
        padding: 20px !important;
    }
    .notification .notification-head {
		font-family: "Raleway",sans-serif;
		text-transform: uppercase;
		font-size: 2.2rem;
		font-weight: 500;
		color: #4a4a4a;
		display: flex;
		justify-content: space-between;
		align-items: baseline;;
    }
    .notification .notification-head span {
		color: #999;
		font-size: 40%;
		text-transform: none;
		text-align: right;
    }

	.notification .notification-subtitle,
	.notification .notification-body {
		padding-top: 10px;	
	}
	.notification .notification-subtitle{
		text-transform: uppercase;
	}
	.notification .notification-body {
		color: #999;
	} */

</style>



